import "../styles/Work.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'

export const Contact = () => {
  return (
    <div className="container spacer" id="contact">
      <div className="col-md-9 mx-auto text-center mb-5">
        <h4 className="text-secondary" data-aos="fade-up" data-aos-duration="1000"><span>Get In Touch</span></h4>
        <p className="text-secondary" data-aos="fade-up" data-aos-duration="1500">Have an exciting project where you need some help? Feel free to reach out.</p>
        <div data-aos="fade-up" data-aos-duration="1800">
          <a href="mailto:erwin@devph.io" className="btn btn-coral btn-lg me-3">
            <FontAwesomeIcon icon={faEnvelope} /> Say Hello
          </a>
        </div>
        <div className="mt-4" data-aos="fade-up" data-aos-duration="2000">
          <a href="https://www.linkedin.com/in/erwinagpasa" target="_blank" rel="noreferrer" className="text-secondary me-4" style={{fontSize: '1.5rem'}}>
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
          <a href="https://github.com/erwinagpasa" target="_blank" rel="noreferrer" className="text-secondary me-4" style={{fontSize: '1.5rem'}}>
            <FontAwesomeIcon icon={faGithub} />
          </a>
          <a href="https://www.instagram.com/erwin.agpasa" target="_blank" rel="noreferrer" className="text-secondary" style={{fontSize: '1.5rem'}}>
            <FontAwesomeIcon icon={faEnvelope} />
          </a>
        </div>
      </div>
    </div>
  )
}
